__turbopack_context__.v({
  "box": "chip-input-module__OZCJGG__box",
  "described": "chip-input-module__OZCJGG__described",
  "entry": "chip-input-module__OZCJGG__entry",
  "wrap": "chip-input-module__OZCJGG__wrap",
});
